import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import BtnComponent from '../buttonComponent/BtnComponent';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import { Grid, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';

function BillsCard({ billsData }) {
  return (
    <div>
      <Card sx={{ width: '340px', height: '176px', borderRadius: ' 8px' }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            {billsData.title}
          </Typography>

          <Grid container spacing={2}>
            <Grid
              item
              xs={3}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Typography variant="nav">{billsData.amount}</Typography>
            </Grid>

            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Chip
                sx={{
                  height: '16px',
                  background: ' #FFE1AF',
                  border: '1px solid #FF9500',
                  boxSizing: ' border-box',
                  borderRadius: '24px',
                  textTransform: 'uppercase',
                  fontSize: 11,
                }}
                label={billsData.orangeLabel}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '27px',
          }}>
          <SecondaryBtnComponent
            title={billsData.secondaryBtnTitle}
            sx={{
              width: ' 157px',
              height: ' 40px',
              padding: ' 8px 24px',
              fontSize: '16px',
            }}
          />
          <BtnComponent
            title={billsData.primaryBtnTitle}
            sx={{
              width: ' 157px',
              height: ' 40px',
              padding: ' 8px 24px',
              fontSize: '16px',
            }}
          />
        </CardActions>
      </Card>
    </div>
  );
}

export default BillsCard;
